import { AnnualAccountReportActionTypes } from "models/actionTypes/annualAccountReportActionTypes";
import { ReduxConstants } from "utils/constants";

export const annualAccountReportAccepted = (id: number): AnnualAccountReportActionTypes => {
  return {
    type: ReduxConstants.AnnualAccountReportActions.ANNUAL_ACCOUNT_REPORT_ACCEPTED,
    payload: id,
  };
};

export const annualAccountReportRejected = (id: number): AnnualAccountReportActionTypes => {
  return {
    type: ReduxConstants.AnnualAccountReportActions.ANNUAL_ACCOUNT_REPORT_REJECTED,
    payload: id,
  };
};

export const annualAccountReportCommented = (id: number): AnnualAccountReportActionTypes => {
  return {
    type: ReduxConstants.AnnualAccountReportActions.ANNUAL_ACCOUNT_REPORT_COMMENTED,
    payload: id,
  };
};

export const annualAccountReportSnoozed = (id: number): AnnualAccountReportActionTypes => {
  return {
    type: ReduxConstants.AnnualAccountReportActions.ANNUAL_ACCOUNT_REPORT_SNOOZED,
    payload: id,
  };
};
